export default "__VITE_ASSET__11b85e94__"